export interface AnalyserParams {
  minDecibels: number;
  maxDecibels: number;
  fftSize: number;
  smoothingTimeConstant: number;
  freqs: number;
  times: number;
}

export const DefaultAnalyserParams: AnalyserParams = {
  fftSize: 2048,
  freqs: 2048,
  times: 2048,
  maxDecibels: 0,
  minDecibels: -160,
  smoothingTimeConstant: 0.9,
};

export function AnalyserSetParams(node: AnalyserNode, params: AnalyserParams) {
  node.minDecibels = params.minDecibels;
  node.maxDecibels = params.maxDecibels;
  node.fftSize = params.fftSize;
  node.smoothingTimeConstant = params.smoothingTimeConstant;
}

export function CalulateVolume(byteFreq: Uint8Array) {
  let sum = 0;
  for (const amplitude of byteFreq) {
    sum += amplitude * amplitude;
  }

  const volume = Math.sqrt(sum / byteFreq.length);

  return volume;
}

export function FindBufferRange(buffer: Float32Array, threshold = 0.2) {
  const SIZE = buffer.length;
  let r1 = 0;
  let r2 = SIZE - 1;

  // Walk up for r1
  for (let i = 0; i < SIZE / 2; i++) {
    if (Math.abs(buffer[i]) < threshold) {
      r1 = i;
      break;
    }
  }

  // Walk down for r2
  for (let i = 1; i < SIZE / 2; i++) {
    if (Math.abs(buffer[SIZE - i]) < threshold) {
      r2 = SIZE - i;
      break;
    }
  }

  return { r1, r2 };
}
